import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function NoDataText() {
  const { t } = useTranslation();

  return (
    <Text fw={500} ta="center" c="gray.6">
      {t('noData')}
    </Text>
  );
}
